<div class="space-y-4">
  <div class="rounded-2xl shadow-lg p-4 sm:p-6 mx-auto bg-white">
    <div class="border-b border-blue-300 pb-2 mb-3 sm:mb-4">
      <h1 class="text-lg sm:text-xl font-bold text-slate-900">3.1 USDM Validation</h1>
    </div>
    <div class="flex flex-col gap-3 sm:gap-0">
      <div class="flex flex-col gap-4 p-4 sm:p-6 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
        <div class="flex flex-col gap-3">
          <span class="text-lg font-semibold text-gray-900">Validating USDM...</span>
          <div class="w-full">
            <p-progressBar [value]="progress"></p-progressBar>
          </div>
        </div>
        <div class="flex flex-col gap-3 mt-2">
          @for (step of validationSteps; track step.name) {
            <div class="flex items-center justify-between gap-3 p-3 rounded-md bg-white border border-gray-200 shadow-sm transition-all duration-200 hover:border-primary hover:shadow-md">
              <div class="flex items-center gap-3 flex-1">
                <span class="text-sm font-medium text-gray-900 min-w-[180px]">{{ step.name }}</span>
                <span class="text-sm font-medium" 
                  [ngClass]="{
                    'text-success': step.status === 'completed', 
                    'text-blue-500': step.status === 'in progress', 
                    'text-error': step.status === 'not started'
                  }">
                  {{ step.status === 'not started' ? 'Not started' : step.status === 'in progress' ? 'In progress' : 'Completed' }}
                </span>
              </div>
              <div class="flex-shrink-0">
                @if (step.status === 'completed') {
                  <i class="pi pi-check text-success text-xl"></i>
                }
                @if (step.status === 'in progress') {
                  <i class="pi pi-spinner pi-spin text-blue-500 text-xl"></i>
                }
                @if (step.status === 'not started') {
                  <i class="pi pi-times-circle text-error text-xl"></i>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="rounded-2xl shadow-lg p-4 sm:p-6 mx-auto bg-white">
    <div class="border-b border-blue-300 pb-2 mb-3 sm:mb-4">
      <h1 class="text-lg sm:text-xl font-bold text-slate-900">3.2 USDM Download</h1>
    </div>
    <div>
      <div class="flex flex-col sm:flex-row gap-3 sm:gap-0">
        <button (click)="downloadUsdm()" [disabled]="disableDownload"
          class="w-full sm:w-auto bg-white hover:bg-gray-300 active:bg-indigo-800 text-black font-semibold py-2.5 sm:py-3 px-3 sm:px-4 rounded-xl shadow-lg border border-gray-200 hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 focus:outline-none cursor-pointer text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 sm:w-5 sm:h-5 mr-2 inline" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v12m0 0l-4-4m4 4l4-4M21 21H3"/>
          </svg>
          Download USDM
        </button>
        <button (click)="openViewer()" [disabled]="disableDownload"
          class="w-full sm:w-auto bg-slate-600 hover:bg-slate-700 active:bg-slate-800 text-white font-semibold py-2.5 sm:py-3 px-3 sm:px-4 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 focus:outline-none cursor-pointer sm:ml-4 text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed">
          View USDM json on our Viewer
        </button>
      </div>
    </div>
  </div>
</div>
